import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4","key":"svg-0"}]]

/**
 * IconCornerUpRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29ybmVyLXVwLXJpZ2h0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik02IDE4di02YTMgMyAwIDAgMSAzIC0zaDEwbC00IC00bTAgOGw0IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/corner-up-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCornerUpRight = createReactComponent('outline', 'corner-up-right', 'CornerUpRight', __iconNode);

export default IconCornerUpRight;